// extracted by mini-css-extract-plugin
export var card = "_qu-0";
export var content = "_qu-2";
export var details = "_qu-3";
export var icon = "_qu-1";
export var iconBlue = "_qu-5";
export var iconBrand = "_qu-4";
export var iconGrayBlue = "_qu-6";
export var iconGreen = "_qu-7";
export var iconIndigo = "_qu-8";
export var iconOrange = "_qu-9";
export var iconPurple = "_qu-a";
export var iconRed = "_qu-b";
export var iconWarning = "_qu-c";